import styled from 'styled-components'

export const NameCell = styled.div`
  font-weight: 600;
  display: flex;
  align-items: flex-start;
`
